import type { Node } from 'reactflow';
import { extractTextNodes } from '@duke-hq/shared-constants/translationSegmentExtract';
import type { NodeData } from './nodes/flowEditorBlockNodeTypes';

// Case-insensitive substring search over every node's text (bubbles and option
// titles), walked via the shared translation extractor so search covers exactly
// the text serving does. Returns the containing node id per matching text run,
// in document order.
export function findConversationMatches(nodes: Node<NodeData>[], query: string): string[] {
  const needle = query.trim().toLowerCase();
  if (needle === '') {
    return [];
  }

  const { segments, locators } = extractTextNodes({ nodes });
  const matches: string[] = [];
  for (let i = 0; i < segments.length; i += 1) {
    const text = segments[i];
    const locator = locators[i];
    if (text === undefined || locator === undefined) {
      continue;
    }
    if (locator.kind !== 'CONVERSATION_SENTENCE' && locator.kind !== 'CONVERSATION_OPTION') {
      continue;
    }
    // Segments carry inline formatting tags and escaped entities; search the
    // plain text so a match isn't split by a tag or hidden behind `&amp;`.
    const plain = text
      .replace(/<\/?t\d+>/g, '')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
    if (plain.toLowerCase().includes(needle)) {
      matches.push(locator.nodeId);
    }
  }
  return matches;
}
